var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phone"},[_c('p',[_vm._v("24小时咨询服务电话")]),_c('b',[_vm._v("18916006004")])])}]

export { render, staticRenderFns }